<template>
    <v-container fluid>
        <v-row class="mt-6 ml-3">
            <h1>病歷號碼: {{patient_code}}</h1>
            <!--<v-btn v-if="[3].includes(account_type)" color="primary" class="mt-1 ml-3" @click="add_tag_dialog=true">新增標籤</v-btn>
            <!-- <span v-if="add_tag_dialog==false && new_tag_dialog==false"> -->
                <!-- <v-chip v-for="(tag, idx2) in patient_tag_list" :key="idx2" class="ma-2" close @click:close="deleted_tag(tag)">{{tag.title}}</v-chip> -->
            <!--<v-chip v-for="(tag, idx2) in patient_tag_list_outside" :key="idx2" class="ma-2">{{tag.title}}</v-chip>
            <!-- </span> -->
        </v-row>
        <v-row v-for="(q, idx) in question_list" :key="idx" class="pa-6">
            <choice v-if="q.type==1" :index="idx+1" :choice="ans_dict[q.id]" :question="q.question"></choice>
            <essay v-if="q.type==2" :index="idx+1" :ans="ans_dict[q.id]" :question="q.question"></essay>
            <matrix v-if="q.type==3" :index="idx+1" :ans="ans_dict" :question="q.question"></matrix>
            <multiplechoice v-if="q.type==4" :index="idx+1" :choice="ans_dict[q.id]" :question="q.question"></multiplechoice>
            <choicewithtext v-if="q.type==5" :index="idx+1" :choice="ans_dict[q.id]" :question="q.question"></choicewithtext>
        </v-row>

        <v-dialog v-model="add_tag_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">新增標籤
                    <v-spacer/>
                    <v-icon @click="add_tag_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-12">
                    <v-row>
                        <v-btn color="primary" class="mt-1 ml-3" @click="new_tag_dialog=true">建立標籤</v-btn>
                        <v-select v-model="selected_tag"  :items="tag_list" @change="add_tag" item-text="title" item-value="id" class="ml-3" placeholder="請選擇選項標籤" outlined></v-select>
                    </v-row>
                    <v-row>
                        <v-chip v-for="(tag, idx2) in patient_tag_list" :key="idx2" class="ma-2" close @click:close="delete_tag(tag)">{{tag.title}}</v-chip>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="tag_confirm" block>確認</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="new_tag_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">建立標籤
                    <v-spacer/>
                    <v-icon @click="new_tag_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row>
                        <v-text-field v-model="tag_name" placeholder="請輸入標籤名稱" single-line class="input_200" outlined></v-text-field>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="new_tag_submit" block>確認</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

import Choice from '../materials/question_user/Choice'
import Essay from '../materials/question_user/Essay'
import Matrix from '../materials/question_user/Matrix'
import Multiplechoice from '../materials/question_user/Multiplechoice'
import Choicewithtext from '../materials/question_user/Choicewithtext'

export default {
    components: {Choice, Essay, Matrix, Multiplechoice, Choicewithtext},
    data(){
        return {
            survey_id: -1,
            survey_participant_id: '',
            patient_code: '',

            question_list: [],
            ans_dict: {},

            new_tag_dialog: false,
            new_one: false,

            add_tag_dialog: false,
            selected_tag: {},

            tag_list: [],
            tag_name: '',
            patient_tag_list: [],
            account_type: parseInt(localStorage.getItem('account_type')),

            patient_tag_list_outside: [],
        }
    },
    created(){
        let check = 's' in this.$route.query && 'i' in this.$route.query && 'u' in this.$route.query
        if(check == false) {
            bus.$emit('alert', {msg: "操作異常", title: "提示",　check: "我知道了"})
            this.$router.push('/question_overview')
        }
        this.survey_id = this.$route.query.s
        this.survey_participant_id = this.$route.query.i
        // this.patient_code = this.$route.query.u

        this.get_question_list()
        this.get_tag_list()
    },
    methods: {
        delete_tag(tag){
            this.patient_tag_list.splice(this.patient_tag_list.findIndex(e=>e.id==tag.id), 1)
        },
        add_tag(){
            if(this.patient_tag_list.findIndex(e=>e.id==this.selected_tag) == -1)
                this.patient_tag_list.push(this.tag_list.find(e=>e.id==this.selected_tag))
        },
        tag_confirm(){
            let post_data = {patient_tag_list: this.patient_tag_list,
                             survey_participant_id: this.survey_participant_id}

            axios.post(host_url+'add_tag/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status){
                    this.patient_tag_list = tmp.patient_tag_list
                    this.patient_tag_list_outside = JSON.parse(JSON.stringify(tmp.patient_tag_list))
                    this.selected_tag = -1
                    this.add_tag_dialog = false
                }
                else
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        // deleted_tag(tag){
        //     let post_data = {tag_id: tag.id,
        //                      survey_participant_id: this.survey_participant_id}

        //     axios.post(host_url+'deleted_tag/', post_data)
        //     .then(response => {
        //         var tmp = response.data
        //         if(tmp.status){
        //             this.patient_tag_list.splice(this.patient_tag_list.findIndex(e=>e.id==tag.id), 1)
        //         }
        //         else
        //             bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
        //     })
        //     .catch((error)=> {
        //         console.log(error);
        //     });
        // },
        get_tag_list(){
            let post_data = {survey_participant_id: this.survey_participant_id}

            axios.post(host_url+'get_tag_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.tag_list = tmp.tag_list
                    this.patient_tag_list = tmp.patient_tag_list
                    this.patient_tag_list_outside = JSON.parse(JSON.stringify(tmp.patient_tag_list))
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        new_tag_submit(){
            let post_data = {tag_name: this.tag_name}

            axios.post(host_url+'new_tag/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status){
                    this.new_tag_dialog = false
                    this.tag_list.push({'id': tmp.id, 'title': this.tag_name})
                    this.patient_tag_list.push({'id': tmp.id, 'title': this.tag_name})
                    this.tag_name = ''
                }
                else
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        get_question_list(){
            let post_data = {survey_id: this.survey_id}

            axios.post(host_url+'get_question_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.question_list = tmp.question_list
                    this.get_ans()
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        get_ans(){
            let post_data = {survey_id: this.survey_id,
                             survey_participant_id: this.survey_participant_id,
                             question_list: this.question_list}

            axios.post(host_url+'get_ans/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    console.log(tmp)
                    this.ans_dict = tmp.ans_dict
                    this.patient_code = tmp.patient_code
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
    },
}
</script>
